const AU_API = (window.AUApi && window.AUApi.bidSheets) || {};
const API = Object.freeze({
    LIST: AU_API.list,
    DETAIL: AU_API.detail,
});

function buildUrl(template, tokens) {
    if (!template) return null;
    return Object.keys(tokens || {}).reduce(
        (url, key) => url.split(`{${key}}`).join(tokens[key]),
        template
    );
}

const extractArray = data => {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.value)) return data.value;
    return [];
};

const getVal = (obj, ...keys) => {
    for (const k of keys) {
        if (obj[k] != null) return obj[k];
        const pascal = k.charAt(0).toUpperCase() + k.slice(1);
        if (obj[pascal] != null) return obj[pascal];
    }
    return '';
};

const fetchJson = async url => {
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`HTTP ${res.status} — ${url}`);
    return res.json();
};

(function initBidSheets() {
    const root = document.querySelector('[data-control="bidSheets"]');
    if (!root) return;

    const q = sel => root.querySelector(sel);

    const els = Object.freeze({
        loading: q('[data-region="loading"]'),
        error: q('[data-region="error"]'),
        empty: q('[data-region="empty"]'),
        list: q('[data-region="list"]'),
    });

    const cloneTemplate = name => {
        const template = root.querySelector(`[data-template="${name}"]`);
        if (!template) return null;
        const clone = template.cloneNode(true);
        clone.removeAttribute('data-template');
        return clone;
    };

    const findRegion = (el, name) =>
        el?.querySelector(`[data-region="${name}"]`) ?? null;

    const setHidden = (el, hidden) =>
        el?.setAttribute('aria-hidden', hidden ? 'true' : 'false');

    const showLoading = () => {
        setHidden(els.loading, false);
        setHidden(els.error, true);
        setHidden(els.empty, true);
        setHidden(els.list, true);
    };

    const showError = () => {
        setHidden(els.loading, true);
        setHidden(els.error, false);
        setHidden(els.empty, true);
        setHidden(els.list, true);
    };

    const showEmpty = () => {
        setHidden(els.loading, true);
        setHidden(els.error, true);
        setHidden(els.empty, false);
        setHidden(els.list, true);
    };

    const showList = () => {
        setHidden(els.loading, true);
        setHidden(els.error, true);
        setHidden(els.empty, true);
        setHidden(els.list, false);
    };

    const renderList = sheets => {
        if (!els.list) return;
        els.list.replaceChildren();
        const fragment = document.createDocumentFragment();

        for (const sheet of sheets) {
            const id = getVal(sheet, 'id', 'bidSheetId');
            const name = getVal(sheet, 'name', 'title', 'description');
            const publishedDate = getVal(sheet, 'publishedDate', 'published');
            if (id === '' || !name) continue;

            const item = cloneTemplate('item');
            if (!item) continue;

            const link = findRegion(item, 'link');
            const nameEl = findRegion(item, 'name');
            const dateEl = findRegion(item, 'date');

            if (link) {
                link.href = buildUrl(API.DETAIL, { id });
                link.setAttribute('aria-label', `${name} (opens PDF in a new tab)`);
            }
            if (nameEl) nameEl.textContent = name;
            if (dateEl) {
                if (publishedDate) {
                    dateEl.textContent = publishedDate;
                } else {
                    const meta = dateEl.closest('.bid-sheets__meta');
                    if (meta) meta.hidden = true;
                }
            }

            fragment.appendChild(item);
        }

        els.list.appendChild(fragment);
    };

    const init = async () => {
        showLoading();
        try {
            const sheets = extractArray(await fetchJson(API.LIST));
            if (!sheets.length) {
                showEmpty();
                return;
            }
            renderList(sheets);
            showList();
        } catch {
            showError();
        }
    };

    init();
})();
